module.exports = __webpack_public_path__ + "./assets/img_hualien_grey__38ba312992dff9f56b892247328af6fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_hualien_grey.jpg
// module id = 602
// module chunks = 12